import React from 'react';
export var JcbCardArt = _ref => {
  var {
    title,
    height,
    width
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "jcb-card-art-title",
    "data-testid": "jcb-card-art",
    height: "".concat(height),
    role: "img",
    viewBox: "0 0 38 24",
    width: "".concat(width),
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("title", {
    id: "jcb-card-art-title"
  }, title), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "jcb-a",
    x1: "-57.527%",
    x2: "232.391%",
    y1: "50.124%",
    y2: "50.124%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#007940"
  }), React.createElement("stop", {
    offset: "22.85%",
    stopColor: "#00873F"
  }), React.createElement("stop", {
    offset: "74.33%",
    stopColor: "#40A737"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#5CB531"
  })), React.createElement("linearGradient", {
    id: "jcb-b",
    x1: ".183%",
    x2: "100.273%",
    y1: "49.96%",
    y2: "49.96%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#007940"
  }), React.createElement("stop", {
    offset: "22.85%",
    stopColor: "#00873F"
  }), React.createElement("stop", {
    offset: "74.33%",
    stopColor: "#40A737"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#5CB531"
  })), React.createElement("linearGradient", {
    id: "jcb-c",
    x1: "-62.802%",
    x2: "253.671%",
    y1: "49.858%",
    y2: "49.858%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#007940"
  }), React.createElement("stop", {
    offset: "22.85%",
    stopColor: "#00873F"
  }), React.createElement("stop", {
    offset: "74.33%",
    stopColor: "#40A737"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#5CB531"
  })), React.createElement("linearGradient", {
    id: "jcb-d",
    x1: ".176%",
    x2: "101.808%",
    y1: "50.006%",
    y2: "50.006%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#1F286F"
  }), React.createElement("stop", {
    offset: "47.51%",
    stopColor: "#004E94"
  }), React.createElement("stop", {
    offset: "82.61%",
    stopColor: "#0066B1"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#006FBC"
  })), React.createElement("linearGradient", {
    id: "jcb-e",
    x1: "-.576%",
    x2: "98.133%",
    y1: "49.914%",
    y2: "49.914%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#6C2C2F"
  }), React.createElement("stop", {
    offset: "17.35%",
    stopColor: "#882730"
  }), React.createElement("stop", {
    offset: "57.31%",
    stopColor: "#BE1833"
  }), React.createElement("stop", {
    offset: "85.85%",
    stopColor: "#DC0436"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#E60039"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0H38V24H0z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M35 0c1.6 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.6 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3zm0 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h32c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M1.55 11.45h1.808c.051 0 .172-.017.223-.017a.807.807 0 00.637-.81.836.836 0 00-.637-.809c-.051-.017-.155-.017-.223-.017H1.55v1.653z",
    fill: "url(#jcb-a)",
    transform: "translate(6 3) translate(17.359 .011)"
  }), React.createElement("path", {
    d: "M3.151.034A3.134 3.134 0 00.017 3.168v3.254h4.425c.104 0 .224 0 .31.018.999.051 1.74.568 1.74 1.463 0 .706-.5 1.309-1.43 1.43v.034c1.016.069 1.79.637 1.79 1.515 0 .947-.86 1.567-1.996 1.567H0v6.37h4.597a3.134 3.134 0 003.134-3.133V.034h-4.58z",
    fill: "url(#jcb-b)",
    transform: "translate(6 3) translate(17.359 .011)"
  }), React.createElement("path", {
    d: "M3.995 8.11a.733.733 0 00-.637-.74c-.035 0-.121-.018-.173-.018H1.55v1.515h1.635c.052 0 .155 0 .173-.017a.733.733 0 00.637-.74z",
    fill: "url(#jcb-c)",
    transform: "translate(6 3) translate(17.359 .011)"
  }), React.createElement("path", {
    d: "M3.188.046A3.134 3.134 0 00.054 3.179v7.731c.879.43 1.791.706 2.704.706 1.084 0 1.67-.654 1.67-1.55v-3.65h2.686v3.633c0 1.412-.878 2.566-3.857 2.566-1.808 0-3.22-.396-3.22-.396v6.595h4.597a3.134 3.134 0 003.134-3.134V.046h-4.58z",
    fill: "url(#jcb-d)",
    transform: "translate(6 3)"
  }), React.createElement("path", {
    d: "M11.849.046a3.134 3.134 0 00-3.134 3.133v4.098c.792-.671 2.17-1.102 4.39-.998 1.189.051 2.463.378 2.463.378v1.326c-.637-.327-1.395-.62-2.376-.688-1.687-.121-2.703.706-2.703 2.152 0 1.463 1.016 2.29 2.703 2.152.981-.069 1.739-.379 2.376-.689v1.326s-1.257.327-2.462.379c-2.221.103-3.599-.327-4.39-.999v7.232h4.597a3.134 3.134 0 003.133-3.134V.046H11.85z",
    fill: "url(#jcb-e)",
    transform: "translate(6 3)"
  }))));
};
JcbCardArt.defaultProps = {
  height: 24,
  title: 'JCB',
  width: 38
};